import { GridColDef } from "@mui/x-data-grid";

export const employeeTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
